import { envConfig } from 'config';
import request from 'utils/request';

const API_BASE_URL = `${envConfig.API_BASE}/api`;

export function getUserRequest(userId, options = {}) {
  return request(`${API_BASE_URL}/v1/users/login/${userId}`, {
    method: 'GET',
    ...options,
  });
}
